// removed by extract-text-webpack-plugin
module.exports = {"bgimage":"src-components-Section-BackgroundImage----backgroundimage-module---bgimage---3e2e4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Section/BackgroundImage/backgroundimage.module.scss
// module id = 309
// module chunks = 204899606439113